var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',_vm._b({attrs:{"popper-class":"global-auto-tooltip"}},'el-tooltip',_vm.option,false),[_vm._t("default",function(){return [_c('div',{class:[_vm.ellipsisClass, _vm.customClass],on:{"mouseenter":_vm.onMouseEnter}},[_vm._v(" "+_vm._s(_vm.$attrs.content)+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }